import React from "react";
import { getValue } from "@utils/lodash";

function SubmenuArrowDownSvgComponent(props: any) {
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" height={
          getValue(props, `size`, "") ? getValue(props, `size`, "") : "18px"
        }
        width={
          getValue(props, `size`, "") ? getValue(props, `size`, "") : "18px"
        } viewBox="0 0 18 18">
  <defs>
    <clipPath id="clip-path-arrow">
      <rect id="Rectangle_18191" data-name="Rectangle 18191" width="18" height="18" transform="translate(-15817 -8380)" fill="#fff"/>
    </clipPath>
  </defs>
  <g id="Mask_Group_299" data-name="Mask Group 299" transform="translate(15817 8380)" clip-path="url(#clip-path-arrow)">
    <path id="expand_more_FILL0_wght300_GRAD0_opsz24" d="M14.6-19.383l-4.5-4.686.839-.874L14.6-21.13l3.661-3.813.839.874Z" transform="translate(-15822.603 -8348.837)" fill={
      getValue(props, `color`, "")
        ? getValue(props, `color`, "")
        : "#5f6368"
    }/>
  </g>
</svg>

    </>
  );
}

export default SubmenuArrowDownSvgComponent;
